import { UserTypeEnum } from 'common/enums/user-type.enum';

export const userTypeMap: Record<UserTypeEnum, string> = {
  [UserTypeEnum.Admin]: 'Admin',
  [UserTypeEnum.SuperAdmin]: 'Super admin',
  [UserTypeEnum.SecurityOfficer]: 'Security officer',
  [UserTypeEnum.WebGuest]: 'Web guest',
  [UserTypeEnum.Undefined]: 'Undefined',
};
